import type { IconSvgObject } from './types';

const Doctor03Icon: IconSvgObject = [
  ["path", { d: "M20 21.9999V15C20 13.8954 19.1046 13 18 13L14 12.9999L12 14.9999L10 12.9999L5.99998 13C4.89542 13 4 13.8954 4 15V21.9999", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15.5 6.5V5.5C15.5 3.567 13.933 2 12 2C10.067 2 8.5 3.567 8.5 5.5V6.5C8.5 8.433 10.067 10 12 10C13.933 10 15.5 8.433 15.5 6.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M16 16V19M17.5 17.5L14.5 17.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default Doctor03Icon;
